@if (content) {
<footer [bottomPanelArea]="'footer'"
        class="page-footer hide-print">
    <!-- footer top -->
    <div class="bg-col-5">
        <div class="wrap p-t-10 p-b-10 p-a-0-s">
            <!-- content -->
            <div class="c-12 c-12-m c-12-s m-b-0 flex flex-column-reverse-s flex-column-reverse-m">
                <!-- icons, trustpilot, social services FOR S -->
                <div class="m-b-0 m-r-0"
                     *ifSize="'SM'">
                    <!-- icons -->
                    <div class="p-a p-t-7 center flex flex-justify-between flex-middle m-l-4 m-r-4">
                        <a [routerLink]="content?.contact_us_link">
                            <i class="icon-email inline-flex p-a-2 b-radius-max bg-col-w"
                               [style.font-size.rem]="1.5"></i>
                            <span class="p2 m-t-2 block">Contact us</span>
                        </a>
                        <a [routerLink]="content.find_store_link">
                            <i class="icon-location inline-flex bg-col-w p-a-2 b-radius-max"
                               [style.font-size.rem]="1.5"></i>
                            <span class="p2 m-t-2 block">Find a Store</span>
                        </a>
                        <a [attr.href]="'tel:' + content.phone_number">
                            <i class="icon-phone inline-flex bg-col-w p-a-2 b-radius-max"
                               [style.font-size.rem]="1.5"></i>
                            <span class="p2 m-t-2 block">{{content.phone_number}}</span>
                        </a>
                    </div>
                    <!-- trustpilot logo S -->
                    <div class="w-12 center m-t-4">
                        <trustpilot-widget [locale]="'en-US'"
                                           [templateId]="'5419b732fbfb950b10de65e5'"
                                           [businessunitId]="'4ad3e0ed000064000504c292'"
                                           [styleHeight]="'24px'"
                                           [styleWidth]="'100%'"
                                           [theme]="'light'"></trustpilot-widget>
                    </div>
                    <!-- social services -->
                    @if (content.social_icons?.length) {
                    <div
                         class="page-footer__social-links flex flex-justify-center-s flex-justify-center-m m-t-8 m-t-5-m m-b-6-s">
                        <!-- link -->
                        @for (icon of content?.social_icons; track icon; let isFirst = $first) {
                        <a [attr.href]="icon.link"
                           target="_blank"
                           rel="nofollow"
                           [ngClass]="isFirst ? 'm-l--1-x m-l--1-l' : 'm-l-2'">
                            <!-- icon -->
                            <div class="bg-col-6 b-radius-max p-a-4 ratio-1-1">
                                <img class="fill p-a-1"
                                     [image]="icon.image">
                            </div>
                        </a>
                        }
                    </div>
                    }
                </div>
                <!-- columns -->
                <div class="c-8-x c-8-l c-12-m c-12-s m-b-0 b-b-s b-t-s b-t-m">
                    <!-- column -->
                    @for (column of content?.columns; track column; let isFirst = $first; let isLast = $last;
                    let i = $index) {
                    <div class="c-3 c-12-m c-12-s m-b-0 m-0"
                         [class.m-r-0]="isLast">
                        <!-- heading / zippy - S, M -->
                        <h3 class="p-b-5 p-a-4-m p-a-4-s flex flex-middle flex-justify-between b-b-m"
                            [class.b-t-s]="!isFirst"
                            sizeClass="XL:fw-bold, SM:p1"
                            [zippyToggle]="['column', i]">
                            <!-- text -->
                            <span *iCms="'heading' of column"></span>
                            <!-- arrow / S, M -->
                            <i class="page-footer__zippy-icon icon-plus"
                               zippyClass="icon-minus !icon-plus"
                               [zippyName]="['column', i]"
                               *ifSize="'SM'"></i>
                        </h3>
                        <!-- links / content zippy - S, M -->
                        @if (column.links?.length) {
                        <ul class="page-footer__links p-l-4-m p-l-4-s p-r-4-m p-r-4-s"
                            sizeClass="SM:ng-hide-animate"
                            [zippyHideUp]="['column', i]"
                            [zippyOff]="client.isX || client.isL"
                            [zippyCloseOnNav]="true">
                            <!-- link item -->
                            @for (item of column.links; track item) {
                            <li class="m-b-2 m-b-4-s">
                                <!-- button -->
                                @if (item.open_cookies_modal && client.sizeId < 2)
                                  {
                                  <button
                                  class="col-11 p2"
                                  *iCms="'label' of item"
                                  (click)="manageCookies()"></button>
                                    }
                                    @if (!item.open_cookies_modal) {
                                    <href class="flex flex-middle"
                                          [link]="item.link">
                                        @if (item.icon) {
                                        <i class="m-r-2"
                                           [ngClass]="item.icon"></i>
                                        }
                                        @if ((item.label_only_on_mobile && client.sizeId < 2)
                                          ||
                                          !item.label_only_on_mobile)
                                          {
                                          <span
                                          class="p2 col-11-s col-11-m"
                                          *iCms="'label' of item"></span>
                                    }
                                </href>
                                    }
                            </li>
                            }
                        </ul>
                        }
                    </div>
                    }
                </div>
                <!-- newsletter & social services -->
                <div class="wrap-s c-4 c-12-m c-12-s m-b-0 m-r-0 flex-column">
                    <!-- newsletter -->
                    <div class="m-b-0 m-r-0">
                        <!-- newsletter heading -->
                        <!-- sizeClass="S:h4, XLM:s1" -->
                        <h3 class="m-b-3 m-t-7-s center-s center-m fw-bold"
                            sizeClass="S:h4"
                            *iCms="'newsletter_heading' of content"></h3>
                        <!-- newsletter copy -->
                        <p class="p2 center-s center-m"
                           *iCms="'newsletter_copy' of content"></p>
                        <!-- newsletter form-->
                        <newsletter-form [source]="'footer'"></newsletter-form>
                    </div>
                    <!-- icons, social services X L -->
                    <div class="m-b-0 m-r-0"
                         *ifSize="'XL'">
                        <div class="p-t-10 p-t-s center flex flex-justify-start flex-middle">
                            @if (content?.contact_us_link) {
                            <a class="m-r-8"
                               [routerLink]="content?.contact_us_link">
                                <i class="icon-email inline-flex p-a-2 b-radius-max bg-col-w"
                                   [style.font-size.rem]="1.5"></i>
                                <span class="p2 m-t-2 block">Contact us</span>
                            </a>
                            }
                            <a [routerLink]="content?.find_store_link"
                               class="m-r-5">
                                <i class="icon-location inline-flex bg-col-w p-a-2 b-radius-max"
                                   [style.font-size.rem]="1.5"></i>
                                <span class="p2 m-t-2 block">Find a Store</span>
                            </a>
                            <a [attr.href]="'tel:' + content.phone_number">
                                <i class="icon-phone inline-flex bg-col-w p-a-2 b-radius-max"
                                   [style.font-size.rem]="1.5"></i>
                                <span class="p2 m-t-2 block">{{content.phone_number}}</span>
                            </a>
                        </div>
                        @if (content.social_icons?.length) {
                        <div class="page-footer__social-links flex flex-justify-center-s m-t-8 m-t-5-m m-t-6-s">
                            <!-- link -->
                            @for (icon of content.social_icons; track icon; let isFirst = $first)
                            {
                            <a [attr.href]="icon.link"
                               target="_blank"
                               rel="nofollow"
                               [ngClass]="isFirst ? 'm-l--1-x m-l--1-l' : 'm-l-2'">
                                <!-- icon -->
                                <div class="p-a-4 ratio-1-1">
                                    <img class="fill p-a-1"
                                         [image]="icon.image_desktop">
                                </div>
                            </a>
                            }
                        </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- footer bottom -->
    <div class="p-t-2 p-b-2 p-t-0-s p-b-0-s wrap p-l-0-s p-r-0-s flex flex-justify-between flex-middle flex-column-s">
        <!-- payment icons -->
        <div class="w-5 w-12-s va-m-x va-m-l m-t-1-s">
            <ul class="page-footer__payments left center-s p-r-6-x p-r-6-l p-t-1-s p-b-1-s">
                @for (item of content.payment_method_icons; track item; let isFirst = $first) {
                <li class="m-r-2"
                    [ngClass]="item.icon || ''"></li>
                }
            </ul>
        </div>
        <!-- trustpilot logo -->
        <ng-container *ifSize="'XL'">
            <trustpilot-widget [locale]="'en-US'"
                               [templateId]="'5419b732fbfb950b10de65e5'"
                               [businessunitId]="'4ad3e0ed000064000504c292'"
                               [styleHeight]="'24px'"
                               [styleWidth]="'100%'"
                               [theme]="'light'"></trustpilot-widget>
        </ng-container>
        <!-- copyright tomandco and links -->
        <div
             class="w-5 w-12-s p-t-1-s p-b-1-s flex flex-justify-right flex-justify-center-s flex-middle center-s flex-column-s">
            <div class="b-t-s p-t-1-s p-b-1-s flex flex-justify-right flex-justify-center-s flex-middle w-12">
                <!-- copyright -->
                <p class="c1 col-11 m-r m-r-2-m m-r-0-s inline-block">©Barker & Stonehouse {{currentYear}}</p>
                <span *ifSize="'SM'"
                      class="col-11 c1 p-l-1 p-r-1">|</span>
                <a class="c1 col-11 inline-block m-r m-r-0-s"
                   href="https://www.tomandco.co.uk/"
                   target="_blank"
                   title="A London based Magento E-commerce Agency">Made by Tom&Co</a>
            </div>
            <!-- bottom links -->
            <ng-container *ifSize="'XL'">
                @if (content.links?.length) {
                <ul class="flex flex-middle center cursor-pointer">
                    <!-- item -->
                    @for (item of content.links; track item; let isFirst = $first; let isLast =
                    $last) {
                    <li class="inline-block no-wrap c1"
                        [ngClass]="{'m-r': !isLast}">
                        @switch (item.open_cookies_modal) {
                        <!-- button -->
                        @case (true) {
                        <button class="col-11"
                                *iCms="'text' of item"
                                (click)="manageCookies()"></button>
                        }
                        <!-- link -->
                        @default {
                        <href class="col-11"
                              [link]="item.link"
                              *iCms="'text' of item">
                        </href>
                        }
                        }
                    </li>
                    }
                </ul>
                }
            </ng-container>
        </div>
    </div>
</footer>
}
